import styled from "styled-components";

export const Wrapper = styled.aside`
  grid-area: options;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0;
  width: ${({ $viewMode }) => $viewMode === "compact" ? "auto" : "100%"};
  gap: ${({ $viewMode }) => $viewMode === "compact" ? "8px" : "10px"};

  > * + * {
    margin-left: 0;
  }

  ${({ $viewMode }) => $viewMode === "compact" && `
    > button {
      min-width: auto;
      padding: 4px 8px;
      font-size: 13px;
    }
  `}
`;
